import { Component, Injector, OnInit } from '@angular/core';
import {SharedDataService} from '../../shared-data.service';
import {enumValue} from '../../constant.enum';
import { env } from '../../../environments/environment-loader';
import { MsalOidcAuthService } from '../../shared/services/msal-oidc-auth/msal-oidc-auth.service';
@Component({
    selector: 'app-sfd-confirmation',
    templateUrl: './sfd-confirmation.component.html',
    styleUrls: ['./sfd-confirmation.component.scss'],
    standalone: false
})
/**
 * classs representing a SfdConfirmationComponent
 */
export class SfdConfirmationComponent implements OnInit {
  enumValue = enumValue;
  public navToResourceUrl = enumValue.CONFIRMATION_PAGE_URL_KEY;
  public sfdUrl = env.gbCiamCommonUtil.SfdAccountUrl;

  /**
   * Create a SfdConfirmationComponent
   * @param sharedDataService
   */
  constructor( private sharedDataService: SharedDataService, private injector: Injector) { }

  /**
   * onInit to check expired token
   */
  ngOnInit() {

  }
  next() {
    const msalAuthSrc = this.injector.get(MsalOidcAuthService);
    this.sharedDataService.setSessionData(enumValue.REGISTER_USER, enumValue.REGISTERED);
    msalAuthSrc.clearCache();
    window.location.href = this.sfdUrl;
  }

}
